import React from 'react';

export default function Community({ contentData, initError, initLoader }) {
  return (
    <>
      <div className="community-content">
        <div className="intro-section">
          <h3 className="section-title">Join Our Community</h3>
          <p className="intro-text">
            Connect with like-minded crypto traders/miners, share knowledge, and grow wealth together in the Bit Aegis Wallet (B.A.W) ecosystem.
          </p>
        </div>
        <div className="social-section">
          <div className="social-grid">
            <a href="https://www.instagram.com/bit.aegis.wallet" className="social-link" target="_blank" rel="noopener noreferrer">
              <span className="link-text">Instagram</span>
            </a>
            <a href="https://www.x.com/ba_wallet" className="social-link" target="_blank" rel="noopener noreferrer">
              <span className="link-text">X</span>
            </a>
            <a href="https://www.facebook.com/bitaegiswallet" className="social-link" target="_blank" rel="noopener noreferrer">
              <span className="link-text">Facebook Page</span>
            </a>
            <a href="https://www.facebook.com/groups/bitaegiswallet" className="social-link" target="_blank" rel="noopener noreferrer">
              <span className="link-text">Facebook Group</span>
            </a>
            <a href="https://www.youtube.com/@bit_aegis_wallet" className="social-link" target="_blank" rel="noopener noreferrer">
              <span className="link-text">YouTube</span>
            </a>
            <a href="https://t.me/bit_aegis_wallet" className="social-link" target="_blank" rel="noopener noreferrer">
              <span className="link-text">Telegram Channel</span>
            </a>
            <a href="https://t.me/+b-45FGInKa1hMzQ1" className="social-link" target="_blank" rel="noopener noreferrer">
              <span className="link-text">Telegram Group</span>
            </a>
            <a href="https://t.me/bitaegiswallet" className="social-link" target="_blank" rel="noopener noreferrer">
              <span className="link-text">Telegram Chat</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
